import Feed from "@/Pages/User/Feed/Feed.vue";
import QuestionForm from "../Pages/User/Questions/Form/QuestionForm.vue";
import Question from "@/Pages/User/Questions/Question/Question.vue";
import QuestionPreview from "@/Pages/User/Questions/QuestionPreview.vue";
import GroupsIndex from "@/Pages/User/Groups/GroupsIndex.vue";
import EditGroup from "@/Pages/User/Groups/EditGroup.vue";
import GroupForm from "@/Pages/User/Groups/GroupForm.vue";
import ManageGroupMembers from "@/Pages/User/Groups/ManageGroupMembers.vue";
import QuestionsIndex from "@/Pages/User/Questions/QuestionsIndex.vue";
import Group from "@/Pages/User/Groups/Group/Group.vue";
import GroupInvitation from "../Pages/User/Groups/GroupInvitation.vue";
import LaunchQuestions from "../Pages/User/Questions/Launch/LaunchQuestions.vue";
import ContactsIndex from "@/Pages/User/Contacts/ContactsIndex.vue";
import StimuliIndex from "@/Pages/User/Stimuli/StimuliIndex.vue";
import StimulusForm from "@/Pages/User/Stimuli/StimulusForm.vue";
import Stimulus from "@/Pages/User/Stimuli/Stimulus.vue";
import ResponsesIndex from "../Pages/User/Responses/ResponsesIndex.vue";
import QuestionResponses from "../Pages/User/Responses/QuestionResponses.vue";
import ConversationsIndex from "@/Pages/Conversations/ConversationsIndex.vue";
import Conversation from "@/Pages/Conversations/Conversation.vue";
import AiConversation from "@/Pages/Conversations/Ai/AiConversation.vue";

export default [
    // Feed
    {
        path: "",
        redirect: {name: "feed"},
        component: Feed,
    },
    {
        path: "feed/:group?",
        component: Feed,
        name: "feed",
    },
    // Questions
    {
        path: "ask",
        component: QuestionForm,
        name: "ask",
    },
    {
        path: "questions/:question/preview",
        component: QuestionPreview,
        name: "questions.preview",
    },
    // Groups
    {
        path: "groups",
        children: [
            {
                path: "",
                component: GroupsIndex,
                name: "groups.index",
            },
            {
                path: "create",
                component: GroupForm,
                name: "groups.create",
            },
            {
                path: ":group",
                children: [
                    {
                        path: "",
                        component: Group,
                        name: "groups.show",
                    },
                    {
                        path: "invitations/:invitation",
                        component: GroupInvitation,
                        name: "groups.invitations.show",
                    },
                    {
                        path: "edit",
                        component: EditGroup,
                        children: [
                            {
                                path: "",
                                component: GroupForm,
                                name: "groups.edit",
                            },
                            {
                                path: "members",
                                component: ManageGroupMembers,
                                name: "groups.edit.members",
                            },
                            // {
                            //     path: "questions",
                            //     component: ManageGroupQuestions,
                            //     name: "groups.edit.questions",
                            // },
                        ],
                    },
                ],
            },
            {
                path: ":group/questions",
                children: [
                    {
                        path: "create",
                        component: QuestionForm,
                        name: "groups.questions.create",
                    },
                    {
                        path: ":question",
                        component: Question,
                        name: "groups.questions.show",
                    },
                    {
                        path: ":question/edit",
                        component: QuestionForm,
                        name: "groups.questions.edit",
                    },
                ],
            },
        ],
    },
    {
        path: "questions",
        children: [
            {
                path: "",
                component: QuestionsIndex,
                name: "questions.index",
            },
            {
                path: "create",
                component: QuestionForm,
                name: "questions.create",
            },
            {
                path: ":question",
                component: Question,
                name: "questions.show",
            },
            {
                path: ":question/edit",
                component: QuestionForm,
                name: "questions.edit",
            },
            {
                path: "launch",
                component: LaunchQuestions,
                name: "questions.launch",
            },
        ],
    },
    // Responses
    {
        path: "responses",
        children: [
            {
                path: "",
                component: ResponsesIndex,
                name: "responses.index",
            },
            {
                path: ":question",
                component: QuestionResponses,
                name: "responses.show",
            },
        ],
    },
    // Stimuli
    {
        path: "stimuli",
        component: StimuliIndex,
        name: "stimuli.index",
    },
    {
        path: "stimuli/create",
        component: StimulusForm,
        name: "stimuli.create",
    },
    {
        path: "stimuli/:stimulus",
        component: Stimulus,
        name: "stimuli.show",
    },
    {
        path: "stimuli/:stimulus/edit",
        component: StimulusForm,
        name: "stimuli.edit",
    },
    // Contacts
    {
        path: "contacts",
        component: ContactsIndex,
        name: "contacts.index",
    },
    {
        path: "contacts/:contact",
        component: ContactsIndex,
        name: "contacts.show",
    },
    // Conversations
    {
        path: "conversations",
        component: ConversationsIndex,
        name: "conversations.index",
    },
    {
        path: "conversations/ai/help",
        component: AiConversation,
        name: "conversations.ai.help",
    },
    {
        path: "conversations/:conversation",
        component: Conversation,
        name: "conversations.show",
    },
];
